import { useQuery } from '@tanstack/react-query';

import { GET_ORG_ANALYTICS_DASHBOARD } from '../../contracts/keys';
import { getOrgAnalyticsDashboard } from '../api/organization';

export { GET_ORG_ANALYTICS_DASHBOARD };

export function useQueryOrgAnalyticsDashboard(
  orgId: string | undefined,
  sessionKey: string
) {
  return useQuery({
    queryKey: [GET_ORG_ANALYTICS_DASHBOARD, { orgId, sessionKey }],
    enabled: !!orgId,
    queryFn: async () => {
      const { data } = await getOrgAnalyticsDashboard(orgId!);
      return data;
    },
    staleTime: Infinity, // Don't auto-refetch while mounted (sessionKey ensures fresh fetch on remount)
    gcTime: 0, // Clean up immediately on unmount
    refetchOnWindowFocus: false, // Don't refetch on window focus (one-time tokens shouldn't be wasted)
  });
}
